// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppButton_whatsappButton__1aFEv","whatsappIcon":"WhatsAppButton_whatsappIcon__Vgauc"};